import { createAxiosClient } from "@ntg/component-library/utilities";

export interface IRouteOperationCS {
    csRouteID: number;
    dataAreaID: string;
    routeId: string;
    operationNumber: number;
    operationPriority: number;
    nextRouteOperationNumber: number;
    operationId: string;
}

export const getRouteOperationsCS = async (
    csRouteID: number,
): Promise<IRouteOperationCS[]> => {
    const axiosAuth = createAxiosClient("D365FO");
    const response = await axiosAuth.get<IRouteOperationCS[]>(
        `/RouteOperation/GetRouteOperationsCS/${csRouteID}`,
    );
    return response.data;
};
